import { useMemo } from 'react';
import { useAppSelector } from 'store/hooks';
import sortAccounts from 'utils/api/sortAccounts';
import { selectSpaceTradingAccounts } from 'reducers/selectors';
import { selectSpacePots } from 'features/pots/reducers/selectors';
import { selectSpaceInfo, selectSpaces } from '../reducers/selectors';
const getAccountsFromSpaceTiers = (accounts, proPreviewAccounts, ultimatePreviewAccounts) => {
    const previewAccounts = [
        ...(proPreviewAccounts || []),
        ...(ultimatePreviewAccounts || []),
    ];
    const merged = [
        ...accounts,
        ...previewAccounts.filter((account) => accounts.find((acc) => acc.id === account.id) === undefined),
    ];
    return merged;
};
export const useAllSpaceAccounts = () => {
    const spaces = useAppSelector(selectSpaces);
    const spaceInfo = useAppSelector(selectSpaceInfo);
    const spacePots = useAppSelector(selectSpacePots);
    const spaceTradingAccounts = useAppSelector(selectSpaceTradingAccounts);
    const spaceAccounts = useMemo(() => {
        const pots = spacePots ? Object.values(spacePots).flat() : [];
        const tradingAccounts = spaceTradingAccounts
            ? Object.values(spaceTradingAccounts).flat()
            : [];
        const accountsFromSpaceInfo = Object.values(spaceInfo)
            .map(({ accounts, proPreviewAccounts, ultimatePreviewAccounts }) => getAccountsFromSpaceTiers(accounts || [], proPreviewAccounts, ultimatePreviewAccounts))
            .flat();
        const accounts = sortAccounts([
            ...accountsFromSpaceInfo,
            ...pots,
            ...tradingAccounts,
        ]);
        const accountsBySpaceId = accounts.reduce((acc, curr) => {
            const { spaceId } = curr;
            if (!spaceId)
                return acc;
            return { ...acc, [spaceId]: [...(acc[spaceId] || []), curr] };
        }, {});
        return spaces.map((space) => ({
            space,
            accounts: accountsBySpaceId[space.id] || [],
        }));
    }, [spacePots, spaceTradingAccounts, spaceInfo, spaces]);
    return spaceAccounts;
};
